<template>
  <el-container>
    <el-aside width="200px">
      <SideMenu></SideMenu>
    </el-aside>
    <el-container>
      <el-header>
        <strong style="color: #fff">后台管理</strong>
        <div class="header-avatar">
          <el-dropdown style='width:55%'>
            <span class="el-dropdown-link">
              {{ userInfo.username}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
<!--                <router-link to="/userCenter"> 个人中心 </router-link>-->
              </el-dropdown-item>
              <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-avatar size="medium" :src="userInfo.avatar"></el-avatar>
          <router-link to="/" >官网首页</router-link
          >
        </div>
      </el-header>
      <el-main>
        <Tabs />
        <div style="margin: 0 15px">
          <router-view ></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import SideMenu from "./inc/SideMenu";
import Tabs from "./inc/Tabs";

export default {
  name: "Home",
  components: { SideMenu, Tabs },
  data() {
    return {
      userInfo: {
        id: "",
        username: "",
        avatar: "",
        roles:""
      },
    };
  },
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }else{
      this.$router.push("/webLogin");
    }
    this.init()
  },
  methods: {
    getUserInfo() {
      this.$axios.get("/sys/userInfo").then((res) => {
        this.userInfo = res.data.data;
      });
    },
    logout() {
      this.$axios.post("/logout").then((res) => {
        localStorage.clear();
        sessionStorage.clear();
        this.$store.commit("resetState");
        this.$router.push("/");
      });
    },
     init(){
    this.$router.push("/Index");
  }
  },

};
</script>

<style scoped>
.el-container {
  padding: 0;
  margin: 0;
  height: 100%;
}

.header-avatar {
  float: right;
  text-align: right;
  width:20% /* 170px -> 10.625rem */;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-header {
  background-color: #17b3a3;
  color: #333;
  text-align: center;
  line-height: 3.75rem /* 60px -> 3.75rem */;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  line-height: 12.5rem /* 200px -> 12.5rem */;
}

.el-main {
  color: #333;
  padding: 0;
}
a {
  text-decoration: none;
}
</style>
